export default "__VITE_ASSET__TTWq11NK__"